import React, { useContext, createContext } from 'react';
import merge from 'lodash/merge';
import { B100, N0, N100, N200, N600 } from '@atlaskit/theme/colors';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

// WARNING: The following types are duplicated from '@atlaskit/atlassian-navigation' so that we can avoid having to include atlassian-navigation as a dependency just for these types
// The more correct solution would be to extract these types and have them in a separate package that we both import from, but this will do for now

/**
 * Pls see the function generateTheme inside - atlassian-frontend/packages/navigation/atlassian-navigation/src/theme/themeGenerator.ts
 * This default generator should overwrite the exact same properties which are being produced by the theme generator.
 */
var themes = {
  default: {
    default: {
      backgroundColor: "var(--ds-background-input, ".concat(N0, ")"),
      color: "var(--ds-text-subtlest, ".concat(N200, ")"),
      borderColor: "var(--ds-border-input, ".concat(N100, ")"),
      borderWidth: "var(--ds-border-width, 1px)",
      iconColor: "var(--ds-icon-subtle, ".concat(N600, ")")
    },
    focus: {
      borderColor: "var(--ds-border-focused, ".concat(B100, ")"),
      backgroundColor: "var(--ds-background-input-pressed, ".concat(N0, ")"),
      boxShadow: "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", "var(--ds-border-input, ".concat(N100, ")"))
    },
    hover: {
      backgroundColor: "var(--ds-background-input-hovered, rgba(222, 235, 255, 0.9))"
    }
  }
};
var getTheme = function getTheme(searchCSS) {
  if (!searchCSS) {
    return themes.default;
  }
  return merge({}, themes.default, searchCSS);
};
var ctx = /*#__PURE__*/createContext(themes.default);
var ThemeProvider = function ThemeProvider(_ref) {
  var value = _ref.value,
    partialSearchCSS = _ref.partialSearchCSS,
    children = _ref.children;
  var theme = getTheme(partialSearchCSS || value);
  return /*#__PURE__*/React.createElement(ctx.Provider, {
    value: theme
  }, children);
};
var useTheme = function useTheme() {
  return useContext(ctx);
};

// todo - deprecate (requires product update)
// eslint-disable-next-line
var _ThemeContext = ctx;

// todo - deprecate (requires product update)
// eslint-disable-next-line
var _createSearchTheme = function _createSearchTheme(suppliedTheme) {
  return suppliedTheme;
};
export {
// private, used only by tests
themes as _themes, ThemeProvider, useTheme,
// deprecated
_ThemeContext,
// deprecated
_createSearchTheme };